
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6b5RU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $15639dab32fd3d41$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $15639dab32fd3d41$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "Adicionar seu pr\xf3prio emoji",
    'fabric.emoji.add.label': 'Adicionar emoji',
    'fabric.emoji.cancel.label': 'Cancelar',
    'fabric.emoji.categories.label': 'Escolha uma categoria de emoji',
    'fabric.emoji.categories.search.results': 'Resultados da pesquisa',
    'fabric.emoji.category.activity': 'Atividade',
    'fabric.emoji.category.all.uploads': 'Todos os carregamentos',
    'fabric.emoji.category.flags': 'Bandeiras',
    'fabric.emoji.category.foods': 'Comidas e bebidas',
    'fabric.emoji.category.frequent': 'Frequentes',
    'fabric.emoji.category.nature': 'Natureza',
    'fabric.emoji.category.objects': 'Objetos',
    'fabric.emoji.category.people': 'Pessoas',
    'fabric.emoji.category.places': 'Viagens e lugares',
    'fabric.emoji.category.productivity': 'Produtividade',
    'fabric.emoji.category.symbols': "S\xedmbolos",
    'fabric.emoji.category.user.uploads': 'Seus carregamentos',
    'fabric.emoji.choose.file.screenReaderDescription': "Selecione um arquivo para o emoji. JPG, PNG ou GIF. Tamanho m\xe1ximo de 1 MB",
    'fabric.emoji.choose.file.title': 'Escolher arquivo',
    'fabric.emoji.delete.description': "Todas as inst\xe2ncias existentes deste emoji ser\xe3o substitu\xeddas por {emojiShortName}",
    'fabric.emoji.delete.label': 'Remover',
    'fabric.emoji.delete.screenreader.tooltip': 'Para excluir um emoji {shortName}, pressione Backspace',
    'fabric.emoji.delete.title': 'Remover emoji',
    'fabric.emoji.delete.tooltip': 'Excluir',
    'fabric.emoji.emojipicker.emoi.roledescription': "bot\xe3o de emoji",
    'fabric.emoji.emojipicker.error': 'Erro!',
    'fabric.emoji.error.delete.failed': "Falha na remo\xe7\xe3o",
    'fabric.emoji.error.image.too.big': 'A imagem selecionada tem mais de 1 MB',
    'fabric.emoji.error.invalid.image': "A imagem selecionada \xe9 inv\xe1lida",
    'fabric.emoji.error.upload.failed': 'Falha no carregamento',
    'fabric.emoji.error.upload.timeout': 'O upload atingiu o tempo limite',
    'fabric.emoji.image.requirements': "JPG, PNG ou GIF. Tamanho m\xe1ximo: 1 MB.",
    'fabric.emoji.name.ariaLabel': 'Insira um nome para o novo emoji',
    'fabric.emoji.picker': 'Seletor de emoji',
    'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Resultados da pesquisa} other {Emojis}}',
    'fabric.emoji.pickerlist.tabpanel': "Painel de a\xe7\xf5es e lista de emojis",
    'fabric.emoji.placeholder': "por exemplo: ol\xe1",
    'fabric.emoji.preview': "Seu novo emoji ({emoji}) ficou \xf3timo",
    'fabric.emoji.preview.title': "Pr\xe9-visualizar",
    'fabric.emoji.retry.label': 'Tentar novamente',
    'fabric.emoji.search.label': 'Nome do emoji',
    'fabric.emoji.search.placeholder': 'Pesquisar',
    'fabric.emoji.search.status': 'Visualizando todos os emojis',
    'fabric.emoji.select.skin.list.ariaLabel': 'Seletor de tom de pele',
    'fabric.emoji.select.skin.tone.ariaLabel': 'Escolha seu tom de pele; {selectedTone} selecionado'
};

});


//# sourceMappingURL=pt_BR.ec04333c.js.map
